import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
const ReportsEndPoint = {
  OUTPUT_SERVICE: '/output/json/v3',
  MSEARCH_SERVICE: '/output/json',
  DOWNLOAD_SERVICE: '/output/file/v3',
  DOWNLOAD_FILE: '/output/download/$sessionId',
  REPORT_TEMPLATES: '/v1/factory/reports',
  BULK_SEARCH: '/v3/search',
  DOWNLOAD_SERVICE_V1: '/api/v1/reports/download',
  OUTPUT_SERVICE_V1: '/api/v1/reports/view',
  REPORT_METRIC_COLUMN_CONFIG:
    '/v1/advanced/reports_configuration/reportType/:REPORT_TYPE/durationRange/:DURATION_RANGE',
  VALIDATE_REPORT_METRIC_CONFIG: '/v1/advanced/reports_configuration/validateDerivedProperty',
  SAVE_REPORT_CONFIGURATION: '/v1/advanced/reports_configuration/save',
} as const;

const CoreSeriveEndPoint = {
  FILTER_API: '/api/v1/orderPlanFilter',
  ORG_DATA: '/admin/api/v1/orgData/lineLevelDisplayNames',
} as const;

const MachineMaintenancePoint = {
  MM_FILTER_DATA: '/api/v1/reports/ticket/getFilters/:factoryId/:reportType',
  AI_ANALYTICS_QUESTION: '/api/v1/analytics/query',
  AI_ANALYTICS_GENERATE_INSIGHTS: '/api/v1/analytics/generateInsights',
  CHATBOT_SUBMIT_FEEDBACK: '/api/v1/analytics/submitFeedback',
} as const;

const FabricInspectionEndPoint = {
  FILTER_SEARCH_FOR_FABRIC_API: '/v1/report/filters',
} as const;

@Injectable({
  providedIn: 'root',
})
export class REnvProvider {
  public svc_host = '';
  public data_gateway = '/no_output_data_service';
  public core_service = '/no_output_data_service';
  public fabric_inpsection_service = '/no_output_fabric_inpsection_service';
  public protocol = '';
  #machine_maintenance_service = '';

  constructor() {
    if (environment.protocol) {
      this.protocol = environment.protocol;
    }

    if (environment.service_host) {
      this.svc_host = environment.service_host;
    }
    if (environment.data_gateway) {
      this.data_gateway = environment.data_gateway;
    }
    if (environment.core_service) {
      this.core_service = environment.core_service;
    }

    if (environment.machine_maintenance) {
      this.#machine_maintenance_service = environment.machine_maintenance;
    }

    if (environment.fabric_inpsection_service) {
      this.fabric_inpsection_service = environment.fabric_inpsection_service;
    }
  }

  public getReportGatewayEnvVar(arg: keyof typeof ReportsEndPoint): string {
    return this.protocol + this.svc_host + this.data_gateway + ReportsEndPoint[arg];
  }

  public getCoreServiceEnvVar(arg: keyof typeof CoreSeriveEndPoint): string {
    return this.protocol + this.svc_host + this.core_service + CoreSeriveEndPoint[arg];
  }

  public getFabricInspectionEnvVar(arg: keyof typeof FabricInspectionEndPoint): string {
    return this.protocol + this.svc_host + this.fabric_inpsection_service + FabricInspectionEndPoint[arg];
  }

  public getMachineMaintenanceEnvVar(arg: keyof typeof MachineMaintenancePoint): string {
    return this.protocol + this.svc_host + this.#machine_maintenance_service + MachineMaintenancePoint[arg];
  }
}
